import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SubTitleService {
  private subTitleSubject = new Subject<string>();
  public subTitle$ = this.subTitleSubject.asObservable();

  updateSubTitle(subTitle: string): void {
    this.subTitleSubject.next(subTitle);
  }
}